import {
  BaseFinancialItem,
  SpendingAccount,
} from 'src/financial/financial-data/hooks/useFinancialItems';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import { Accordion } from '@mantine/core';
import { IconCoins } from '@tabler/icons-react';
import { AccordionHeader } from 'src/financial/financial-data/net-worth/AccordionHeader';
import SpendingAccountsTable from 'src/financial/financial-data/tables/SpendingAccountsTable';
import { useCurrency } from 'src/common/hooks/useCurrency';

type SpendingAccountsAccordionProps = {
  spendingAccounts: SpendingAccount[];
  activeItem: string | null;
  onSubmit: () => void;
  metadata: DynamicUiEntitiesMetadata;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};
export const SpendingAccountsAccordion = ({
  spendingAccounts,
  activeItem,
  onSubmit,
  metadata,
  onRowClick,
}: SpendingAccountsAccordionProps) => {
  const currency = useCurrency();
  const accordionKey = 'SPENDING_ACCOUNTS';
  const title = 'Spending accounts';

  return (
    <Accordion.Item role="region" key={accordionKey} value={accordionKey}>
      <Accordion.Control>
        <AccordionHeader
          title={title}
          count={spendingAccounts.length}
          amount={addSpendingAccounts(spendingAccounts)}
          currency={currency}
          Icon={IconCoins}
          isOpen={activeItem === accordionKey}
        />
      </Accordion.Control>
      <Accordion.Panel>
        <SpendingAccountsTable
          financialItems={spendingAccounts}
          pl="xxs"
          titleParts={[title]}
          onSubmit={onSubmit}
          metadata={metadata}
          onRowClick={onRowClick}
        />
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export function addSpendingAccounts(items: SpendingAccount[]) {
  return items.reduce((accumulator, i) => accumulator + i.currentBalance, 0);
}
